import React, { useMemo } from 'react';
import { apiHolder as api, apis } from 'api';
import { MAIL_MENU_ITEM } from '@web-mail/common/constant';
import MailMultOperPanelConfig from '@web-mail/common/components/MailMenu/mailMenuConifg/MailMultOperPanelConfig';
import useMailStore from '@web-mail/hooks/useMailStoreRedux';
import MailMenuIcon from '@web-mail/common/components/MailMenu/MailMenuIcon/MailMenuIcon';
import useState2RM from '../../hooks/useState2ReduxMock';
import MailMultOpConfig2AllFolder from '@web-mail/common/components/MailMenu/mailMenuConifg/MailMultOpConfig2AllFolder';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import { useAppSelector } from '@web-common/state/createStore';
import { folderIdIsAllFolder, isFollowFolder, isAllFollowFolder } from '@web-mail/util';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MailMultOperationBtns = props => {
    const { size = 'normal', domProps } = props;
    const [mailSearching] = useState2RM('mailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [selectedKeys] = useState2RM('selectedKeys');
    const [searchList] = useMailStore('searchList');
    const [activeIds] = useState2RM('activeIds');
    const [mailDataList] = useMailStore('mailDataList');
    const [selected] = useState2RM('mailListStateTab');
    const [mailSearchMoreAccounts] = useState2RM('mailSearchMoreAccounts');
    const MailList = isSearching ? searchList : mailDataList;
    const handleExportTrack = useCreateCallbackForEvent(() => {
        trackApi.track('pcMail_click_export', { folderId: selectedKeys.id, isSearching, tab: selected });
    });
    const isShowWaiting = useAppSelector(state => isFollowFolder(state.mailReducer.selectedKeys.id));
    const isAllWaiting = useAppSelector(state => isAllFollowFolder(state.mailReducer.selectedKeys.id));
    const checkedMails = useMemo(() => {
        const list = [];
        if (activeIds && MailList) {
            activeIds.forEach(_id => {
                const mail = MailList.find(item => item.entry.id === _id);
                mail && list.push(mail);
            });
        }
        return list;
    }, [activeIds, MailList]);
    const menuConfig = useMemo(() => {
        return [
            {
                key: MAIL_MENU_ITEM.EXPORT,
                onClick: (mails, defaultClick) => {
                    handleExportTrack();
                    defaultClick && defaultClick(mails);
                },
            },
            {
                key: MAIL_MENU_ITEM.WM_UNFOLLOW_STATIC,
                show: (mails, defaultShow) => {
                    if (isShowWaiting) {
                        return false;
                    }
                    if (defaultShow && typeof defaultShow == 'function') {
                        return defaultShow(mails);
                    }
                    return false;
                },
            },
            {
                key: MAIL_MENU_ITEM.WMFOLLOW_STATIC,
                show: (mails, defaultShow) => {
                    if (isAllWaiting) {
                        return true;
                    }
                    if (defaultShow && typeof defaultShow == 'function') {
                        return defaultShow(mails);
                    }
                    return false;
                },
            },
            {
                key: MAIL_MENU_ITEM.RED_FLAG,
                show: (mails, defaultShow) => {
                    if (!isAllWaiting) {
                        if (defaultShow && typeof defaultShow == 'function') {
                            return defaultShow(mails);
                        }
                    }
                    return false;
                },
            },
        ];
    }, [isShowWaiting, isAllWaiting]);
    const folderIsAllFolders = useMemo(() => {
        return (!isSearching && folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) || (isSearching && mailSearchMoreAccounts);
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, isSearching, mailSearchMoreAccounts]);
    const isSameAccount = useMemo(() => {
        if (checkedMails && checkedMails.length) {
            try {
                const accountSet = new Set();
                checkedMails.forEach(mail => {
                    accountSet.add(mail._account);
                });
                return accountSet.size === 1;
            }
            catch (e) {
                console.error(e);
            }
        }
        return true;
    }, [checkedMails]);
    const defaultMenu = useMemo(() => (folderIsAllFolders || !isSameAccount ? MailMultOpConfig2AllFolder : MailMultOperPanelConfig), [folderIsAllFolders, isSameAccount]);
    return (React.createElement("div", { className: `oper-wrap ${size === 'mini' ? 'mini' : ''}` }, checkedMails.length ? React.createElement(MailMenuIcon, { mail: checkedMails, menu: menuConfig, defaultMenu: defaultMenu, menuType: "text", domProps: domProps }) : React.createElement(React.Fragment, null)));
};
export default MailMultOperationBtns;
